import "./src/styles/global.scss";

// Load Trustpilot widget script
export const onClientEntry = () => {
  if (typeof window !== 'undefined' && !document.getElementById('trustpilot-widget-script')) {
    const script = document.createElement('script');
    script.id = 'trustpilot-widget-script';
    script.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
    script.async = true;
    document.head.appendChild(script);
  }
};
